// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  background-color: #d2042d;
  color: #fff;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  display: inline-flex;
  height: 50px;
  padding: 8px 60px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
}

.button:hover {
  box-shadow: none !important;
  border: none !important;
  background-color: #d2042d !important;
}

.action-button {
  font-family: Roboto;
  color: rgb(210, 4, 45);
  display: flex;
  gap: 0.5rem;
  cursor: pointer;
  align-items: center;
  border: none;
}
.pointer {
  cursor: pointer;
}

.common-container {
  margin-left: 4.5rem;
  margin-right: 3.5rem;
}
.common-search .ant-input-outlined {
  border-radius: 6px !important;
  border-color: #d9d9d9 !important;
  border: 1px solid #d9d9d9;
}
.ant-input-outlined.common-search:focus-within,
.ant-input-outlined.common-search:hover {
  border-color: #000 !important;
  border-radius: 6px !important;
  border: 1px solid #000 !important;
}
.no-margin {
  margin: 0;
}
.loading-css {
  display: flex;
  justify-content: center;
  align-items: center;
}
.disable-button,
.restrict-button {
  cursor: not-allowed !important;
  opacity: 0.8 !important;
  color: #808080 !important;
}
.restrict-button {
  background: rgba(0, 0, 0, 0.04) !important;
  border-color: #d9d9d9 !important;
}
.default-color {
  color: #d2042d;
  font-family: "Roboto";
}
.default-font {
  font-family: "Roboto";
}
.default-background {
  background: #d2042d !important;
}
.superscript {
  font-weight: 300;
  font-size: 13px;
}
.small-font {
  font-size: 13px;
}
.zero-padding {
  padding: 0;
}
.back-navigation {
  margin-right: 1rem;
  cursor: pointer;
}
.campaign-link {
  color: #d2042d !important;
  text-decoration: underline !important;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  display: inline-block;
}
.rotate-ellipsis-icon {
  transform: rotate(90deg);
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
}

.required {
  color: #d2042d !important;
}
.main-title-size {
  font-size: 19px !important;
  font-weight: 700 !important;
  font-family: "Montserrat";
}
.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  background-color: #d2042d;
}
.campaign-export-btn {
  border-radius: 5px !important;
  border: 1px solid var(--Colors-Text-100, #b3b5b4) !important;
  background: #fff !important;
  height: 40px;
  margin-right: 20px !important;
}

/* Clipboard icon for copy */
.copy-icon {
  cursor: pointer;
  color: #5a5656ff;
  opacity: 0; /* hidden by default */
  transition: opacity 0.2s ease-in-out;
  margin-left: 10px;
}
.segment-sizes {
  font-family: Roboto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin: 0.5rem 0 1rem 0rem;
  font-family: "Roboto";
  font-weight: 600;
  font-size: 14px;
}

.icon-size {
  height: 24px;
  width: 24px;
}

.card-headings {
  font-size: 16px;
  font-weight: 400;
}
.error-block {
  color: #d2042d;
  margin-top: 0.3rem;
  display: inline-block;
}

.variable_charge_rates {
  font-size: 14px;
  font-family: Roboto;
}

@media (max-width: 1024px) {
  .common-container {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }
}
/* For Mobile */
@media (min-width: 0px) and (max-width: 768px) {
  .main-title-size {
    font-size: 23px !important;
    font-weight: 700 !important;
    font-family: "Montserrat";
  }
  .common-container {
    margin-left: 2.5rem;
    margin-right: 1.5rem;
  }
  .mobile-card-title-size,
  .mobile-card-buttons {
    font-family: Roboto;
    font-size: 14px !important;
    font-weight: 500 !important;
  }
  .field-text-size {
    font-size: 14px !important;
    font-weight: 400 !important;
    font-family: Roboto;
  }
  .field-text-size-label {
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: Roboto;
  }
  .campaign-id-sub-fields {
    font-size: 14px !important;
    font-family: Roboto;
    font-weight: 400 !important;
  }
  .back-button-navigation {
    width: 36px;
    padding: 5px 10px 0 0;
  }
  /* Icon sizes in mobile */
  .icon-size {
    height: 22px;
    width: 22px;
  }
  .back-navigation-arrow {
    width: 18px;
  }
  /* Payments styling in Buyer Dashboard and Payments  */

  .dashboard-container .payment-header,
  .buyer-payment-card .payment-header {
    padding-bottom: 10px;
  }
  .dashboard-container .payment-id,
  .buyer-payment-card .payment-id {
    font-family: Roboto;
    color: #d2042d;
    font-weight: 400;
    font-size: 13px;
    line-height: 100%;
    letter-spacing: 0%;
  }
  .dashboard-container .payment-name,
  .buyer-payment-card .payment-name {
    font-family: Roboto;
    color: #000;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .dashboard-container .payment-price,
  .buyer-payment-card .payment-price {
    font-family: Roboto;
    color: #0a0f0d;
    font-size: 1.1875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    align-items: center;
  }

  .dashboard-container .payment-label,
  .buyer-payment-card .payment-label {
    font-family: Roboto;
    color: #8e9190;
    font-size: 13px;
    font-weight: 400;
  }
  .dashboard-container .payment-value,
  .buyer-payment-card .payment-value {
    font-family: Roboto;
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
  .download-column {
    /* color: #d2042d; */
    display: flex;
    justify-content: flex-end;
    font-size: 1rem;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  .dashboard-invoice-download {
    font-family: Roboto;
    padding: 0.75rem;
    background: #d2042d !important;
    color: #fff !important;
    width: 80vw;
    border-radius: 6px;
  }
  .campaign-export-btn {
    margin-right: 0;
  }
  .mobile-arrow {
    width: 18px;
  }
}

@media (max-width: 449px) {
  .main-title-size {
    font-size: 19px !important;
  }

  .mobile-card-title-size {
    font-size: 16px !important;
    font-weight: 500;
  }

  .segment-sizes {
    font-size: 14px;
  }
  .mobile-card-buttons {
    font-family: Roboto;
    font-size: 14px !important;

    font-weight: 500 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,4DAA4D;EAC5D,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU,EAAE,sBAAsB;EAClC,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;;IAEE,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA,yBAAyB;EACzB;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA,sDAAsD;;EAEtD;;IAEE,oBAAoB;EACtB;EACA;;IAEE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,0BAA0B;;IAE1B,2BAA2B;EAC7B;AACF","sourcesContent":[".button {\n  background-color: #d2042d;\n  color: #fff;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: normal;\n  display: inline-flex;\n  height: 50px;\n  padding: 8px 60px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n}\n\n.button:hover {\n  box-shadow: none !important;\n  border: none !important;\n  background-color: #d2042d !important;\n}\n\n.action-button {\n  font-family: Roboto;\n  color: rgb(210, 4, 45);\n  display: flex;\n  gap: 0.5rem;\n  cursor: pointer;\n  align-items: center;\n  border: none;\n}\n.pointer {\n  cursor: pointer;\n}\n\n.common-container {\n  margin-left: 4.5rem;\n  margin-right: 3.5rem;\n}\n.common-search .ant-input-outlined {\n  border-radius: 6px !important;\n  border-color: #d9d9d9 !important;\n  border: 1px solid #d9d9d9;\n}\n.ant-input-outlined.common-search:focus-within,\n.ant-input-outlined.common-search:hover {\n  border-color: #000 !important;\n  border-radius: 6px !important;\n  border: 1px solid #000 !important;\n}\n.no-margin {\n  margin: 0;\n}\n.loading-css {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.disable-button,\n.restrict-button {\n  cursor: not-allowed !important;\n  opacity: 0.8 !important;\n  color: #808080 !important;\n}\n.restrict-button {\n  background: rgba(0, 0, 0, 0.04) !important;\n  border-color: #d9d9d9 !important;\n}\n.default-color {\n  color: #d2042d;\n  font-family: \"Roboto\";\n}\n.default-font {\n  font-family: \"Roboto\";\n}\n.default-background {\n  background: #d2042d !important;\n}\n.superscript {\n  font-weight: 300;\n  font-size: 13px;\n}\n.small-font {\n  font-size: 13px;\n}\n.zero-padding {\n  padding: 0;\n}\n.back-navigation {\n  margin-right: 1rem;\n  cursor: pointer;\n}\n.campaign-link {\n  color: #d2042d !important;\n  text-decoration: underline !important;\n}\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 80%;\n  display: inline-block;\n}\n.rotate-ellipsis-icon {\n  transform: rotate(90deg);\n  font-size: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #000;\n}\n\n.required {\n  color: #d2042d !important;\n}\n.main-title-size {\n  font-size: 19px !important;\n  font-weight: 700 !important;\n  font-family: \"Montserrat\";\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\n  background-color: #d2042d;\n}\n.campaign-export-btn {\n  border-radius: 5px !important;\n  border: 1px solid var(--Colors-Text-100, #b3b5b4) !important;\n  background: #fff !important;\n  height: 40px;\n  margin-right: 20px !important;\n}\n\n/* Clipboard icon for copy */\n.copy-icon {\n  cursor: pointer;\n  color: #5a5656ff;\n  opacity: 0; /* hidden by default */\n  transition: opacity 0.2s ease-in-out;\n  margin-left: 10px;\n}\n.segment-sizes {\n  font-family: Roboto;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  margin: 0.5rem 0 1rem 0rem;\n  font-family: \"Roboto\";\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.icon-size {\n  height: 24px;\n  width: 24px;\n}\n\n.card-headings {\n  font-size: 16px;\n  font-weight: 400;\n}\n.error-block {\n  color: #d2042d;\n  margin-top: 0.3rem;\n  display: inline-block;\n}\n\n.variable_charge_rates {\n  font-size: 14px;\n  font-family: Roboto;\n}\n\n@media (max-width: 1024px) {\n  .common-container {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n}\n/* For Mobile */\n@media (min-width: 0px) and (max-width: 768px) {\n  .main-title-size {\n    font-size: 23px !important;\n    font-weight: 700 !important;\n    font-family: \"Montserrat\";\n  }\n  .common-container {\n    margin-left: 2.5rem;\n    margin-right: 1.5rem;\n  }\n  .mobile-card-title-size,\n  .mobile-card-buttons {\n    font-family: Roboto;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n  }\n  .field-text-size {\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    font-family: Roboto;\n  }\n  .field-text-size-label {\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    font-family: Roboto;\n  }\n  .campaign-id-sub-fields {\n    font-size: 14px !important;\n    font-family: Roboto;\n    font-weight: 400 !important;\n  }\n  .back-button-navigation {\n    width: 36px;\n    padding: 5px 10px 0 0;\n  }\n  /* Icon sizes in mobile */\n  .icon-size {\n    height: 22px;\n    width: 22px;\n  }\n  .back-navigation-arrow {\n    width: 18px;\n  }\n  /* Payments styling in Buyer Dashboard and Payments  */\n\n  .dashboard-container .payment-header,\n  .buyer-payment-card .payment-header {\n    padding-bottom: 10px;\n  }\n  .dashboard-container .payment-id,\n  .buyer-payment-card .payment-id {\n    font-family: Roboto;\n    color: #d2042d;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 100%;\n    letter-spacing: 0%;\n  }\n  .dashboard-container .payment-name,\n  .buyer-payment-card .payment-name {\n    font-family: Roboto;\n    color: #000;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .dashboard-container .payment-price,\n  .buyer-payment-card .payment-price {\n    font-family: Roboto;\n    color: #0a0f0d;\n    font-size: 1.1875rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    display: flex;\n    align-items: center;\n  }\n\n  .dashboard-container .payment-label,\n  .buyer-payment-card .payment-label {\n    font-family: Roboto;\n    color: #8e9190;\n    font-size: 13px;\n    font-weight: 400;\n  }\n  .dashboard-container .payment-value,\n  .buyer-payment-card .payment-value {\n    font-family: Roboto;\n    color: #000;\n    font-size: 13px;\n    font-weight: 500;\n  }\n  .download-column {\n    /* color: #d2042d; */\n    display: flex;\n    justify-content: flex-end;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 24px; /* 150% */\n  }\n\n  .dashboard-invoice-download {\n    font-family: Roboto;\n    padding: 0.75rem;\n    background: #d2042d !important;\n    color: #fff !important;\n    width: 80vw;\n    border-radius: 6px;\n  }\n  .campaign-export-btn {\n    margin-right: 0;\n  }\n  .mobile-arrow {\n    width: 18px;\n  }\n}\n\n@media (max-width: 449px) {\n  .main-title-size {\n    font-size: 19px !important;\n  }\n\n  .mobile-card-title-size {\n    font-size: 16px !important;\n    font-weight: 500;\n  }\n\n  .segment-sizes {\n    font-size: 14px;\n  }\n  .mobile-card-buttons {\n    font-family: Roboto;\n    font-size: 14px !important;\n\n    font-weight: 500 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
